export const profile = {
  name: 'Fantahun Fekadu',
  role: 'Lead Full-Stack Developer · AI/ML Engineer',
  tagline: 'I build production AI systems and the distributed backends that carry them.',
  location: 'Addis Ababa, Ethiopia',
  timezone: 'GMT+3',
  email: 'fantahunfekadu1@gmail.com',
  phone: '+251 938 646 985',
  whatsapp: 'https://wa.me/251938646985',
  telegram: 'solvynf',
  github: 'https://github.com/FANIMAN',
  linkedin: 'https://linkedin.com/in/fantahun-fekadu',
  upwork: 'https://upwork.com/freelancers/~01a0ffd6a31a5b74d9',
  fiverr: 'https://fiverr.com/fantahunfekadu',
  availability: 'Open to lead & senior AI / backend roles',
};

export const stats = [
  { value: '5+', label: 'Years in production engineering' },
  { value: '6', label: 'Countries worked across, remote' },
  { value: '10+', label: 'Distributed services shipped' },
  { value: '4', label: 'Teams led as technical lead' },
];

/** Short, high-signal claims used under the hero. */
export const heroHighlights = [
  'LLM orchestration & RAG',
  'Event-driven microservices',
  'Fintech & payment rails',
  'Cloud, CI/CD & observability',
];
